export const roman =[
    {id:1,   name:"Legionnaire", wood:120, clay:100, iron:150, crop:30},
    {id:2,   name:"Praetorian", wood:100, clay:130, iron:160, crop:70},
    {id:3,   name:"Imperian", wood:150, clay:160, iron:210, crop:80},
    {id:4,   name:"Equites Legati", wood:140, clay:160, iron:20, crop:40},
    {id:5,   name:"Equites Imperatoris", wood:550, clay:440, iron:320, crop:100},
    {id:6,   name:"Equites Caesaris", wood:550, clay:640, iron:800, crop:180},
    {id:7,   name:"Battering ram", wood:900, clay:360, iron:500, crop:70},
    {id:8,   name:"Fire Catapult", wood:950, clay:1350, iron:600, crop:90},
    {id:9,   name:"Senator", wood:30750, clay:27200, iron:45000, crop:37500},
    {id:10,   name:"Settler", wood:4600, clay:4200, iron:5800, crop:4400},
]